import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  OnInit,
} from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { GigyaService } from "../../services/gigya.service";
import { SpinnerComponent } from "../../shared/icons/spinner/spinner.component";

@Component({
  selector: "app-authenticated",
  standalone: true,
  imports: [RouterOutlet, SpinnerComponent],
  templateUrl: "./authenticated.component.html",
  styleUrl: "./authenticated.component.css",
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AuthenticatedComponent implements OnInit {
  public loading: boolean = true;

  constructor(
    private gigyaService: GigyaService,
    private router: Router,
  ) { }

  public async ngOnInit(): Promise<void> {
    if (this.gigyaService.data) {
      this.loading = false;
      return;
    }

    const res = await this.gigyaService.execute(this.gigyaService.client.accounts.getAccountInfo, {
      include: "groups,rba",
    });

    if (res.errorCode !== 0) {
      console.error("Failed to get account info:", res);
      const urlTree = this.router.parseUrl(this.router.url);
      urlTree.queryParams = {};
      const backTo = urlTree.toString() || '/';
      this.router.navigate(["/"], { queryParams: { backTo }, queryParamsHandling: "merge" });
      return;
    }

    console.log("Account info with groups:", res);
    if (
      !res['groups'] || !res['groups'].organizations ||
      res['groups'].organizations.length === 0
    ) {
      console.warn("User has no organizations or groups");
    }

    this.gigyaService.setData(res);
    this.loading = false;
  }
}
